import React, { ReactNode } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { ValueOf } from '@/common/common.types';
import { SummarizeMinimizedResponse } from '@/dashboard/services/dashboardApi';
import { convertTimestampToDate } from '@/common/utils/date.utils';
import { DashboardBandsLabel } from '@/dashboard/utils/DashboardCalculations/dashboardCalculations.utils';

const CheckCircularOutlineIcon = (
  <ArrowCircleRightOutlinedIcon
    fontSize="small"
    sx={{ color: 'success.main', height: 16, width: 16 }}
  />
);
const WarningIcon = (
  <WarningAmberIcon fontSize="small" sx={{ color: 'custom.errorContent', height: 16, width: 16 }} />
);
const CheckMarkIcon = (
  <CheckIcon fontSize="small" sx={{ color: 'success.main', height: 16, width: 16 }} />
);

export const noStatus = {
  icon: (<></>) as ReactNode,
  label: '',
  color: 'transparent',
};

type IconMapperType = {
  [k in 'Accepted' | 'Attention' | 'Empty' | 'Validated' | 'None' | 'Rejected']: {
    label: string;
    icon: React.ReactNode;
    color: string;
  };
};
type DateSubmittedType = ValueOf<SummarizeMinimizedResponse>['lastSubmission'];

export function formatSubmittedTimeOrBlank(dateSubmitted: DateSubmittedType, label: string) {
  return (
    dateSubmitted ? `${label} ${convertTimestampToDate(dateSubmitted)}` : label
  ) as DashboardBandsLabel;
}

function getIconMapper(dateSubmitted: DateSubmittedType) {
  return {
    Accepted: {
      icon: CheckCircularOutlineIcon,
      label: formatSubmittedTimeOrBlank(dateSubmitted, 'Accepted'),
      color: 'primary.main',
    },
    Attention: {
      icon: WarningIcon,
      label: 'Attention Required',
      color: 'custom.errorContent',
    },
    Empty: {
      icon: WarningIcon,
      label: 'No Records Found',
      color: 'custom.errorContent',
    },
    Validated: {
      icon: CheckMarkIcon,
      label: formatSubmittedTimeOrBlank(dateSubmitted, 'Validated'),
      color: 'primary.main',
    },
    Rejected: {
      icon: WarningIcon,
      label: formatSubmittedTimeOrBlank(dateSubmitted, 'Rejected'),
      color: 'custom.errorContent',
    },
    None: noStatus,
  } as IconMapperType;
}

export { getIconMapper };
